import config from 'config';
import authHeader from '../helpers/authHeaders';
 
export const reservationRemarkService = {
  add,
  update,
  getReservationRemarks,
  getReservationRemark,
  delete: _delete
};

function getQueryString(params) {
  var esc = encodeURIComponent;
  return Object.keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&');
}
 
function getReservationRemarks(filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  let qs = '?' + getQueryString(filters);
  return fetch(`${config.apiUrl}/reservation_remarks/${qs}`, requestOptions).then(handleResponse);
}
 
function getReservationRemark(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
 
  return fetch(`${config.apiUrl}/reservation_remarks/${id}`, requestOptions).then(handleResponse);
}
 
function add(reservation_remark) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(reservation_remark)
  };
 
  return fetch(`${config.apiUrl}/reservation_remarks`, requestOptions).then(handleResponse);
}
 
function update(id, reservation_remark) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(reservation_remark)
  };
 
  return fetch(`${config.apiUrl}/reservation_remarks/${id}`, requestOptions).then(handleResponse);
}
 
// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };
 
  return fetch(`${config.apiUrl}/reservation_remarks/${id}`, requestOptions).then(handleResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('token');
}
 
function handleResponse(response) {
  console.log(response.body);
  return response.text().then(text => {
    console.log(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        window.location.reload(true);
      }
 
      const error = (text && ((text.indexOf('{') > -1 && JSON.parse(text).error) || text)) || response.statusText || 'Something went wrong.';
      return Promise.reject(error);
    }
    const data = text && JSON.parse(text);
    return data;
  });
}